var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.query.source === 'espaceMembre')?_c('v-sheet',{staticClass:"mx-auto mt-2 mt-md-6 mt-lg-12",attrs:{"max-width":"800"}},[_c('v-alert',{attrs:{"type":"warning","text":"","dismissible":""}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('avertissements.redirectionDepuisEspaceMembre'))}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }